/** Parses an ISO 8601 string (YYYY-MM-DD) or Date object into a JS Date. Returns null for empty/invalid input. */
export function parseDate(value) {
  if (!value) return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  // An HTML date input is a calendar date, not UTC midnight. Parsing it as UTC
  // and formatting locally moves filters to the previous day west of UTC.
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? date : null;
  }
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

/** Expects ISO 8601 string (YYYY-MM-DD) or Date; returns YYYY-MM-DD for date inputs. Omit value for today. Uses browser-local timezone. */
export function toInputDate(value) {
  const d = value ? parseDate(value) : new Date();
  if (!d) return null;
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** Expects ISO 8601 string (YYYY-MM-DD) or Date; returns DD/MM/YYYY for display. Uses browser-local timezone. */
export function toDisplayDate(value) {
  const d = parseDate(value);
  if (!d) return null;
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

export const dateFormatChanger = toDisplayDate;
export const apiDateFormat = toApiDate;

/** Accepts ISO 8601 string (YYYY-MM-DD) or Date object; returns "YYYY-MM-DD 00:00:00" for API calls. Omit/falsy for today (UTC). Invalid input returns null. Fixes the double-space produced by old apiDateFormat(undefined). Server interprets as UTC midnight. */
export function toApiDate(value) {
  if (!value) return `${new Date().toISOString().slice(0, 10)} 00:00:00`;
  const dateStr = toInputDate(value);
  return dateStr ? `${dateStr} 00:00:00` : null;
}
